(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[573],{

/***/ 11620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/tip-calculator",
      function () {
        return __webpack_require__(71110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 71110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ tip_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Tools/TipCalculator.jsx


function TipCalculator() {
    const [bill, setBill] = (0,react.useState)("");
    const [tipPercent, setTipPercent] = (0,react.useState)(15);
    const [noOfPeople, setNoOfPeople] = (0,react.useState)(1);
    const [totalTip, setTotalTip] = (0,react.useState)(0);
    const [total, setTotal] = (0,react.useState)(0);
    const [tipPerPerson, setTipPerPerson] = (0,react.useState)(0);
    const [totalPerPerson, setTotalPerPerson] = (0,react.useState)(0);
    const calculateTip = (0,react.useCallback)(()=>{
        let billAmount = parseFloat(bill);
        let tipPercentage = parseFloat(tipPercent);
        let people = parseInt(noOfPeople);
        let totalTipAmount = parseFloat((billAmount * (tipPercentage / 100)).toFixed(2));
        let totalAmount = parseFloat((billAmount + totalTipAmount).toFixed(2));
        let tipPerPersonAmount = parseFloat((totalTipAmount / people).toFixed(2));
        let totalPerPersonAmount = parseFloat((totalAmount / people).toFixed(2));
        setTotalTip(totalTipAmount);
        setTotal(totalAmount);
        setTipPerPerson(tipPerPersonAmount);
        setTotalPerPerson(totalPerPersonAmount);
    }, [
        bill,
        tipPercent,
        noOfPeople
    ]);
    (0,react.useEffect)(()=>{
        calculateTip();
    }, [
        calculateTip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white w-full sm:w-[450px] py-10 px-[30px] rounded-lg drop-shadow-2xl mx-auto h-fit sm:h-[550px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "bill",
                                className: "lbl text-sm font-medium text-gray-700",
                                children: "Bill"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "input-box bg-blue-100 text-blue-700 px-2 py-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "$"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "number",
                                        value: bill,
                                        placeholder: "0.00",
                                        id: "bill",
                                        className: "val text-sm font-semibold bg-blue-100 border-none outline-none w-24 text-right text-blue-700",
                                        onChange: (e)=>setBill(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lbl text-sm font-medium text-gray-700",
                                children: "Tip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "tip-amount",
                                className: "val text-sm font-semibold text-gray-700",
                                children: [
                                    "$",
                                    totalTip ? totalTip.toFixed(2) : "0"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gray-200 my-[30px] h-[1px] w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lbl text-sm font-medium text-gray-700",
                                children: "Total Amount"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "total-amount",
                                className: "val text-sm font-semibold text-gray-700",
                                children: [
                                    "$",
                                    total ? total.toFixed(2) : "0"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mb-8 mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "tip",
                                className: "lbl text-sm font-medium text-gray-700",
                                children: "Tip %"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "tip-percent",
                                className: "val text-sm font-semibold text-gray-700",
                                children: tipPercent
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "range",
                        min: "1",
                        id: "tip",
                        value: tipPercent,
                        className: "w-full my-2 h-1 cursor-pointer bg-gray-200 rounded-lg appearance-none range-sm",
                        onChange: (e)=>{
                            setTipPercent(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: "no-of-people",
                                className: "lbl text-sm font-medium text-gray-700",
                                children: "No. Of People"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                id: "split-num",
                                className: "val text-sm font-semibold text-gray-700",
                                children: noOfPeople
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "range",
                        min: "1",
                        max: "15",
                        id: "no-of-people",
                        value: noOfPeople,
                        className: "w-full h-1 cursor-pointer my-2 bg-gray-200 rounded-lg appearance-none range-sm",
                        onChange: (e)=>{
                            setNoOfPeople(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-8 bg-blue-100 rounded-md p-[10px] text-blue-700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lbl text-sm font-medium",
                                children: " Tip Per Person "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "tip-per-person",
                                className: "val text-sm font-semibold",
                                children: [
                                    "$",
                                    tipPerPerson ? tipPerPerson.toFixed(2) : "0"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper flex items-center justify-between my-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "lbl text-sm font-medium",
                                children: " Total Per Person "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                id: "total-per-person",
                                className: "val text-sm font-semibold",
                                children: [
                                    "$",
                                    totalPerPerson ? totalPerPerson.toFixed(2) : "0"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Tools_TipCalculator = (TipCalculator);

// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/tip-calculator/index.jsx





const BlogData = [
    {
        id: 1,
        question: "How do I use the Tip Calculator to calculate tips for a service?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "To use the Tip Calculator to calculate tips for a service, simply enter the total bill amount and the percentage of the tip you want to leave. The calculator will automatically calculate the tip amount for you, and add it to the total bill. This makes it easy to quickly and accurately calculate tips for any service, whether it's dining out at a restaurant or receiving a personal service like a haircut or massage."
            })
        })
    },
    {
        id: 2,
        question: "How do I split a bill using the Tip Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "If you're dining out with friends or splitting a bill with multiple people, you can easily use the Tip Calculator to split the bill evenly. Simply enter the total bill amount, the percentage of the tip you want to leave, and the number of people in your party. The calculator will automatically calculate the total tip amount and the amount each person owes, making it easy to divide the bill fairly and quickly."
            })
        })
    },
    {
        id: 3,
        question: "What is the benefit of using the Tip Calculator for bill management?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Using the Tip Calculator for bill management has many benefits. It saves time and eliminates the need for mental math, ensuring you leave the right amount of gratuity every time. It also allows you to split bills easily and fairly, making it perfect for dining out with friends or paying for a service with multiple people. Additionally, it helps you stay within your budget by giving you an accurate total for your bill, including tip."
            })
        })
    },
    {
        id: 4,
        question: "How accurate is the Tip Calculator for calculating tips?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "The Tip Calculator is extremely accurate for calculating tips, as it takes into account the total bill amount and the percentage of the tip you want to leave. This ensures that you leave the right amount of gratuity every time, whether you're dining out at a restaurant or receiving a personal service like a haircut or massage."
            })
        })
    },
    {
        id: 5,
        question: "Is the Tip Calculator easy to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, the Tip Calculator is very easy to use. Simply enter the total bill amount and the percentage of the tip you want to leave, and the calculator will do the rest. You can also adjust the number of people in your party if you need to split the bill evenly."
            })
        })
    },
    {
        id: 6,
        question: "Can I use the Tip Calculator for services other than dining out?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, you can use the Tip Calculator for any service where you need to leave a tip, such as a personal service like a haircut or massage. It's also great for tipping delivery drivers, hotel staff, or anyone who provides a service that deserves a gratuity."
            })
        })
    },
    {
        id: 7,
        question: "Is the Tip Calculator tool free to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, the Tip Calculator tool is completely free to use. There's no need to sign up or download any software, and you can use it as many times as you need. It's a great tool for simplifying bill management and ensuring you leave the right amount of gratuity every time."
            })
        })
    },
    {
        id: 8,
        question: "Can I adjust the tip amount manually?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, you can adjust the tip amount manually if you prefer to tip more or less than the suggested percentage. Our tool will still calculate the total bill for you based on the adjusted tip amount."
            })
        })
    },
    {
        id: 9,
        question: "What percentage should I tip?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "The percentage you tip can vary depending on the quality of service, the location, and personal preferences. A common guideline is to tip 15-20% for restaurants and 10-15% for other services. However, you can adjust the percentage based on your satisfaction with the service."
            })
        })
    }
];
const TipCalc = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[80px] flex flex-col items-center xl:flex-row gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Tip Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.region",
                                content: "IN"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.position",
                                content: "22.351115;78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "ICBM",
                                content: "22.351115, 78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "author",
                                content: "BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "publisher",
                                content: "BoloSign "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: "https://www.bolosign.com/calculators/tip-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: "https://www.bolosign.com/calculators/tip-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: "Tip Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://bolosign.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:url",
                                content: "https://www.bolosign.com/calculators/tip-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: "Tip Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[30px] w-full xl:w-[50%] text-center xl:text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                                children: "Tip Calculator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-[16px] xl:text-[18px] font-light",
                                children: "Easily calculate tips and split bills with our free Tip Calculator tool. Determine tip amounts for different percentages of the service cost and add them to your total bill with just a few clicks. Whether you're dining out with friends or paying for a service, our Tip Calculator simplifies the process and ensures you leave the right amount of gratuity. Try our Tip Calculator today and enjoy hassle-free bill management!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "xl:flex flex-col gap-[15px] w-full pr-[100px] mt-[120px] hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "font-medium text-[30px] leading-[60px]",
                                        children: "BoloForms makes it easier"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-light",
                                        children: "With Boloforms' tip calculator, users can quickly and accurately determine how much to tip their server or bartender, without the need for mental math."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-light",
                                        children: "Overall, Boloforms' tip calculator is just one of the many useful tools that the company offers to help make everyday tasks more efficient and convenient for its users."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tools_TipCalculator, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Tip Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var tip_calculator = (TipCalc);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(11620); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);